<template>
<div id="iddownload">

  <img class="cimg" :src="require('@/assets/download/img-01.png')" />
  <img class="cimg" :src="require('@/assets/download/img-02.png')" />
  <img class="cimg" :src="require('@/assets/download/img-03.png')" />
  <img class="cimg" :src="require('@/assets/download/img-04.png')" />

  <div class="download" @click="download()" v-track="{ name: 'download' }">立即下载</div>

  <!-- <div class="llq" v-if="showllq"> -->
  <van-overlay :show="showllq" @click="showllq = false" v-track="{ name: 'close_showllqs' }">

    <img :src="require('@/assets/download/openbrower.jpg')" class="showllq">

  </van-overlay>

</div>
</template>

<script>

import Overlay from 'vant/lib/overlay';
import "vant/lib/overlay/style";

import {
  api_downloadapp
} from "@/api"


export default {
  name: 'Download',
  data(){
      return {
        showllq:false
      }
  },
  components: {
    'van-overlay': Overlay,
  },
  created() {
    this.$track('start_download')
    this.$store.dispatch('share/initShareParams', {
      title: '七天学堂下载',
      desc: '提供专业的学情分析，名师课堂，错题整理等服务'
    })
  },
  methods: {
    download() {
      let sUserAgent = navigator.userAgent.toLowerCase()
      let isIOS = sUserAgent.match(/iphone os/i) == "iphone os" || sUserAgent.match(/ipad/i) == "ipad"
      let weixin = /micromessenger/.test(sUserAgent)
      let userAgent = navigator.userAgent
      let iswIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端

      if(weixin){
        this.showllq = true;
        return;
      }

      // 默认跳转APP对应页面
      let scheme = 'septnetstudent://'
      // if (this.$route.query.courseGuid) scheme += ('course/' + this.$route.query.courseGuid)
      window.location.href = scheme
      if (isIOS || iswIOS) {
        setTimeout(() => {
          window.location.href =
            "https://itunes.apple.com/app/%E4%B8%83%E5%A4%A9%E5%AD%A6%E5%A0%82/id1392893889"
        }, 2000)
      } else {
        setTimeout(()=>{
          api_downloadapp().then(res => {
            let url = res.data.url;  
            window.location.href = url; 
          }).catch(ex => console.log(ex));
        },2000)
      }
    },
  }
}
</script>

<style lang="scss">
.cimg {
    width: 100%;
}

.showllq{
      width: 250px;
    float: right;
    margin-right: 15px;
}

.download {
    position: fixed;
    bottom: 0;
    color: white;
    background: #ed5b68;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-left: 5%;

}
</style>
